<template>
  <div class="row">
    <div v-for="item in items" class="col-12 col-md-4 read-only">
      <div class="label">{{ item.label }}</div>
      <div class="value" :class="{ bold: item.bold }">{{ item.value }}</div>
    </div>
  </div>
</template>

<script>
import { originItems, destinationItems } from '../lib/constants/address-read-only-items.js'
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: {
    type: {
      type: String,
      default: 'origin',
    },
    fullObject: {},
  },
  data() {
    return {
      itemMapping: {
        origin: originItems,
        destination: destinationItems,
      },
      items: [],
    }
  },
  watch: {
    fullObject(newValue) {
      if (newValue.id === undefined || newValue.id === null) {
        this.assignDefaultValue()
        return
      }

      const newItems = []
      this.items.forEach((item) => {
        const newItem = { ...item }

        newItem.bold = true

        if (newItem.key === 'city') {
          newItem.value = this.fullObject[newItem.key] || '-'

          newItems.push(newItem)
          return
        }

        if (newValue[`start_${newItem.key}_on`] === null || newValue[`end_${newItem.key}_on`] === null) {
          newItem.value = '-'

          newItems.push(newItem)
          return
        }

        newItem.value = `${newValue[`start_${newItem.key}_on`]} - ${newValue[`end_${newItem.key}_on`]}`
        newItems.push(newItem)
      })

      this.items = newItems
    },
  },
  mounted() {
    this.assignDefaultValue()
  },
  methods: {
    assignDefaultValue() {
      this.items = cloneDeep(this.itemMapping[this.type])
    },
  },
}
</script>

<style lang="scss" scoped>
.read-only {
  .label {
    color: $mep-color-text-200;
  }

  .value {
    color: $mep-color-text-300;

    &.bold {
      color: $mep-color-text-400;
      font-weight: 600;
    }
  }
}
</style>
